<template>
<div v-if="showconditions" class="card">
    <div class="card-content">
        <p class="disclaimer">EliteFit.AI will not be responsible for any copyright violation done by the users.</p>
        <p class="upload-info">Please only upload your own content.</p>
        <p class="legal-info">Read more about it in our <a href="https://docs.google.com/document/d/1lwO91JIY-JMifwldqnmGCiabSCYh3A_G_7lwpPnWdwI/edit?usp=sharing" target="_blank">Guidelines</a> and <a target="_blank" href="/privacy-policy">Privacy Policy</a>.</p>
        <b-button @click="agreed()" class="btn btn-success">I UNDERSTAND</b-button>
  </div>
</div>
</template>
<script>
export default {
    name:'conditions',
    data: function() {
        return {
            showconditions:true
        }
    },
    methods: {
        async agreed() {
            localStorage.setItem('contentAgreed', 'true');
            this.$router.push('/management/video/add');
        },
        async redirectToPrivacy() {
          this.$router.push('/privacy-policy');
        }
    },
    mounted() {
        try {
            const agreeFlag = localStorage.getItem('contentAgreed');
            if(agreeFlag) {
                this.$router.push('/management/video/add');
            }
        }
        catch(error) {
            localStorage.setItem('contentAgreed', 'false');
        }
    }
}
</script>
<style scoped>
.clearfix {
    margin-right: 10px;
    height: 50px;
    width: 50px;
}
.card {
  background-color: #f7f7f7;
  border-radius: 6px;
  padding: 20px;
  width: 100%;
  margin: 0 auto;
}

.card-content {
  text-align: center;
}

.disclaimer {
  font-size: 18px;
  margin-bottom: 10px;
}

.upload-info {
  font-size: 16px;
  margin-bottom: 10px;
}

.legal-info {
  font-size: 14px;
  margin-bottom: 10px;
}

a {
  color: blue;
  text-decoration: underline;
}

.understand {
  font-weight: bold;
}

</style>
